import request from '@/helpers/request'

// userService have all api of user when logged
export default {
  async login(data) {
    return await request.post('users/login', data)
  },
  async getInfo() {
    return await request.get('user')
  },
  async refresh() {
    return await request.post('users/refresh')
  },
  async resetPassword(data) {
    return await request.post('users/reset_password', data)
  },
  async confirmResetPassword(data) {
    return await request.put('users/reset_password', data)
  },
  async saveToken(token) {
    return await request.post('/push-notification/save-token', {
      device_token: token
    })
  }

}
